import { cn } from "@/lib/utils";

type BreadcrumbsProps = {
  items: React.ReactNode[];
};

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  return (
    <div className="flex flex-row gap-4 overflow-hidden text-sm">
      {items.map((item, index) => (
        <>
          <div className="text-foreground-2">/</div>
          <div
            className={cn("overflow-hidden", {
              "text-foreground": index === items.length - 1,
              "text-foreground-4": index !== items.length - 1,
            })}
          >
            {item}
          </div>
        </>
      ))}
    </div>
  );
};
